import React, { HTMLAttributes, InputHTMLAttributes } from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ margin?: string }>`
  width: 100%;
  margin-bottom: ${({ margin }) => (margin ? margin : "20px")};
`;

const Input = styled.input`
  height: 42px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  font-size: 14px;
  color: #080808;
  opacity: 0.8;
  font-weight: normal;
  padding: 0px 10px;
  outline-color: #efa21e;

  &::placeholder {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    letter-spacing: -0.01em;

    color: #bebfc6;
  }
`;

const Label = styled.label`
  display: flex;
  margin-bottom: 5px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;

  letter-spacing: -0.01em;

  color: #1e2029;
`;

function TextInput({
                       margin,
                       wrapperStyle,
                       inputLabel,
                       error,
                       ...rest
                   }: ITextInput) {
    return (
        <Wrapper margin={margin} style={wrapperStyle}>
            {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
            <Input id={"input-" + rest.name} {...rest} />
            {error && <span style={{ color: "red" }}>{error}</span>}
        </Wrapper>
    );
}

export interface ITextInput extends InputHTMLAttributes<HTMLInputElement> {
    inputLabel?: string;
    margin?: string;
    wrapperStyle?: React.CSSProperties;
    error?: string | null;
}

export default TextInput;
